import { render, staticRenderFns } from "./PlanoCAEE.vue?vue&type=template&id=22d06a6a&scoped=true"
import script from "./PlanoCAEE.vue?vue&type=script&lang=js"
export * from "./PlanoCAEE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d06a6a",
  null
  
)

export default component.exports